import _typeof from "@babel/runtime/helpers/typeof";
import _get from "lodash/get";
import _isArray from "lodash/isArray";
import _isEmpty from "lodash/isEmpty";
import "core-js/modules/es6.array.map.js";

var isString = function isString(value) {
  return typeof value === 'string' || value instanceof String;
};

var isObject = function isObject(value) {
  return _typeof(value) === 'object';
};
/**
 *
 * Extract the string from the given structured content or
 * just return the string if it is a string.
 *
 *
 * @param {Any} structuredContent An array, object, string, or number
 * representing the content.
 *
 * @return {String} text content to be used
 *
 */


export var extractStructuredContent = function extractStructuredContent(structuredContent) {
  if (!structuredContent || _isEmpty(structuredContent)) {
    return '';
  }

  if (isString(structuredContent)) {
    return structuredContent;
  }

  if (_isArray(structuredContent)) {
    return structuredContent.map(function (content) {
      return extractStructuredContent(content);
    }).join(' ');
  }

  if (isObject(structuredContent)) {
    return extractStructuredContent(_get(structuredContent, 'props.children', ''));
  }

  return '';
};
export default {
  extractStructuredContent: extractStructuredContent
};